<template>
  <div
    class="sprite-popup setting-popup"
    v-show="boxData.judgeBox"
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}"
    @mousedown.stop.prevent
    @click="on$ElClicked()"
  >
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)"
      :style="{'cursor': 'move'}"
    >设置</div>
    <div class="setting-popup__content">
      <div class="row" v-for="(row, i) in rows" :key="i">
        <div class="item" v-for="(item, j) in row" :key="j" @click="openChild(item)">
          <div class="item__icon">
            <icon
              :url="`../../../static/svg/popups/${item.icon || item.name}.svg`"
              :width="item.iconWidth || 28"
              :height="item.iconHeight || 26"
            ></icon>
            <icon
              :classNames="['active']"
              :url="`../../../static/svg/popups/${item.icon || item.name}-2.svg`"
              :width="item.iconWidth || 28"
              :height="item.iconHeight || 26"
            ></icon>
          </div>
          <span>{{(item || {}).text}}</span>
        </div>
      </div>
    </div>

    <div class="setting-popup__close" @click="close">
      <i class="icon-popup-close"></i>
    </div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="onMaskClicked()"></div>
  </div>
</template>

<script>
import spritePopup from "./spritePopup";
import popup from "../mixins/popup";

export default {
  mixins: [popup, spritePopup],
  data() {
    return {
      popupType: "bgPopup",
      items: [
        { text: "基础", disabled: false, name: "basic" },
        { text: "替换", disabled: false, name: "swap" },
        { text: "变焦", disabled: false, name: "zoom" },
        { text: "滤镜", disabled: false, name: "filter" },
        { text: "剪辑时长", disabled: false, name: "clip", icon: "clip-bg" },
        { text: "铺设", disabled: false, name: "laying" },
        {
          text: "删除背景",
          disabled: false,
          name: "remove",
          iconWidth: 25,
          iconHeight: 23
        }
      ],
      rows: [],
      itemNameMap: {
        Color: ["basic", "swap", "remove"],
        Image: ["basic", "swap", "zoom", "filter", "laying", "remove"],
        Video: ["basic", "swap", "zoom", "filter", "clip", "remove"]
      },
      showChildName: "", // 当前显示的子弹窗的名称
      reports: {
        zoom: "material_setting_panel_base,click_bgzoom,设置面板_一级_背景变焦",
        laying:
          "material_setting_panel_base,click_bgStyle,设置面板_一级_背景铺设",
        clip:
          "material_setting_panel_base,click_bg_video_cut,设置面板_一级_背景剪辑",
        remove:
          "material_setting_panel_base,click_bg_bgDelete,设置面板_一级_背景删除"
      }
    };
  },
  created() {},
  methods: {
    getUsingItems() {
      let bg = this.SelectScenes_Msg.background;
      let bgType = bg.data.type;
      let names = this.itemNameMap[bgType];
      let filtered = this.items.filter(v => {
        return names.indexOf(v.name) > -1;
      });
      return filtered;
    },

    openChild(item) {
      this.$analysis(this.reports[item.name]);
      let isDo = this.setSprite(item);
      if (isDo) {
        return;
      }

      this.$bus.emit("FeaturesPop_vue", {
        name: `${item.name}Setting.bg`,
        type: 1,
        initialX: this.boxData.fix.x,
        initialY: this.boxData.fix.y,
        isChild: true,
        source: this,
        sprite: this.sprite
      });

      this.showChildName = item.name;
      this.toggleMask(true);
    },

    setSprite(item) {
      let isDo = false;
      switch (item.name) {
        case "swap":
        case "swap":
          this.$bus.emit("materialPane_vue", { type: "bg" });
          this.close();
          this.$store.commit("save_BgOperation", "swap");
          isDo = true;
          break;

        case "filter":
          this.$bus.emit("FeaturesPop_vue", {
            name: `${item.name}Setting`,
            type: 1,
            initialX: this.boxData.fix.x,
            initialY: this.boxData.fix.y,
            isChild: true,
            source: this,
            sprite: { type: "bg" }
          });
          this.toggleMask(true);
          isDo = true;
          break;

        case "remove":
          this.startRemoveBg();
          isDo = true;
          break;

        default:
          break;
      }

      return isDo;
    },

    onMaskClicked() {
      let name = `${this.showChildName}Setting.bg`;
      this.closeNextPopup(name);
      this.closeNextPopup("filterSetting");
      this.$bus.emit("windowMousedown_vue");
    },

    startRemoveBg() {
      let sceneBgData = this.SelectScenes_Msg.background.data.data || {};
      let bgOpts = {
        // 设置场景背景
        resourceId: null, // 背景资源id
        fileType: null, // 背景资源type
        type: "Color",
        data: {
          color: "#FFFFFF",
          blur: 0,
          opacity: 1
        },
        zoomActive: false
      };
      this.SelectScenes_Msg.setBackground(bgOpts, null, true);
    }
  }
};
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 164px;
  // min-height: 280px;
  // max-height: 368px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding-top: 0;
    padding-bottom: 14px;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.row {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 75px;
  width: 140px;
  margin: auto;

  &:after {
    content: " ";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translatex(-50%);
    width: 128px;
    height: 1px;
    background-color: #f0f0f8;
    border-radius: 1px;
  }

  &:last-child {
    &:after {
      content: none;
    }
  }
}

.item {
  width: 70px;
  height: 60px;
  text-align: center;
  cursor: pointer;

  & .icon-component.active {
    display: none;
  }
  &:hover {
    & .icon-component {
      display: none;
    }
    & .icon-component.active {
      display: inline-block;
    }
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/bgPopup.vue